export default {
  page: {
    title: "고객지원",
    subtitle: "고객과의 소통을 최우선으로 합니다",
    tabs: [
      { key: "notices", label: "공지사항" },
      { key: "data", label: "자료실" },
      { key: "quotation", label: "견적문의" },
    ],
    searchPlaceholder: "검색어 입력",
    tableNo: "번호",
    tableTitle: "제목",
    tableDate: "작성일",
    tableCategory: "구분",
    important: "중요",
    view: "보기",
    collapse: "접기",
    empty: "검색 결과가 없습니다.",
    download: "다운로드",
    loading: "불러오는 중...",
    fetchError: "데이터를 불러오지 못했습니다. 잠시 후 다시 시도해주세요.",
    retry: "다시 시도",
    requiredInfo: "견적 의뢰 시 필요 정보",
    process: "견적 프로세스",
    quoteInquiry: "견적 문의하기",
  },
};